import { render } from "./safravi.vue?vue&type=template&id=42e94ff9"
import script from "./safravi.vue?vue&type=script&lang=js"
export * from "./safravi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/tabibekhanevade-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__